import React, { useState } from 'react'
import { isAxiosError } from 'axios'
import { Box, Button, Flex, Loading, Modal, Text } from '@workwhile/ui'
import { JetClockOutCallReport, Work } from 'pages/Shifts/ShiftDetail/types'
import { useJetTimesheetPhoto } from 'queries/jet/useJetTimesheetPhoto'

type JetTimesheetPhotoProps = {
  work: Work
  report: JetClockOutCallReport | null | undefined
  requiresJetClockOutCallReport: boolean
}

export const JetTimesheetPhoto = ({
  work,
  report,
  requiresJetClockOutCallReport,
}: JetTimesheetPhotoProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [photoEnabled, setPhotoEnabled] = useState(false)

  const {
    data: photoUrl,
    isLoading: photoLoading,
    isError: photoError,
    error: photoErrorObj,
    refetch: refetchPhoto,
  } = useJetTimesheetPhoto(work.id, { enabled: photoEnabled })

  const photoForbidden =
    isAxiosError(photoErrorObj) && photoErrorObj.response?.status === 403

  if (!requiresJetClockOutCallReport) {
    return null
  }

  if (!report?.hasTimesheetPhoto) {
    return null
  }

  return (
    <Box width={200} minHeight={130} backgroundColor="offWhite" p={2}>
      <Text fontWeight="bold" mb={2}>
        JET Timesheet Photo
      </Text>
      {photoLoading ? (
        <Loading />
      ) : photoUrl ? (
        <>
          <img
            src={photoUrl}
            alt="JET Timesheet"
            onClick={() => setIsModalOpen(true)}
            style={{
              width: '100%',
              height: 'auto',
              display: 'block',
              borderRadius: 4,
              cursor: 'pointer',
            }}
          />
          <Text fontSize={0} textAlign="center" mt={1} color="textSecondary">
            JET timesheet photo
            <br />
            (click to expand)
          </Text>
        </>
      ) : photoForbidden ? (
        <Text fontSize={0} color="danger" textAlign="center">
          You don&apos;t have permission to view this photo.
        </Text>
      ) : (
        <Flex justifyContent="center">
          <Button
            variant="secondary"
            onClick={() => {
              if (photoError) {
                refetchPhoto()
              } else {
                setPhotoEnabled(true)
              }
            }}
            disabled={photoLoading}
          >
            {photoError ? 'Retry Load Timesheet Photo' : 'Load Timesheet Photo'}
          </Button>
        </Flex>
      )}
      <Modal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        {...({ width: 'auto', maxWidth: '90vw' } as any)}
      >
        {photoUrl ? (
          <img
            src={photoUrl}
            alt="JET Timesheet - Full Size"
            onClick={() => setIsModalOpen(false)}
            style={{
              maxWidth: '85vw',
              maxHeight: '85vh',
              objectFit: 'contain',
              cursor: 'pointer',
            }}
          />
        ) : null}
      </Modal>
    </Box>
  )
}
